<template>
  <v-app-bar
    height="fit-content"
    style="
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.09) !important;
      position: relative;
    "
    class=""
    elevation="2"
  >
    <v-container fluid class="pa-1">
      <v-row class="px-3" noGutters>
        <v-col cols="2">
          <img
            @click="this.$router.push({ name: 'HomePage' })"
            style="cursor: pointer; width: 10rem"
            src="@/assets/images/brandify/new_logo_promxa.svg"
            alt=""
          />
        </v-col>
        <v-col cols="4" class="d-flex align-center"> </v-col>
        <!-- <v-col cols="1"></v-col> -->
        <v-col cols="6" class="d-flex justify-end align-center ga-2">
          <div class="massage-icon">
            <v-badge
              v-if="massageArr"
              :color="
                massageArr.length > 0 ? 'rgba(236, 34, 31, 1)' : 'transparent'
              "
              :content="massageArr.length"
              dot
            >
              <v-btn
                icon=""
                id="show-hidden-notification"
                variant="text"
                class="show-hidden-massage pa-0"
              >
                <svg
                  width="37"
                  height="36"
                  viewBox="0 0 37 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25.3216 9.02441H12.2488C11.3305 9.0254 10.45 9.39063 9.80071 10.04C9.15138 10.6893 8.78614 11.5697 8.78516 12.488V21.5608C8.78614 22.4791 9.15138 23.3595 9.80071 24.0089C10.45 24.6582 11.3305 25.0234 12.2488 25.0244H12.7852V28.3577C12.7851 28.4714 12.8142 28.5832 12.8695 28.6824C12.9248 28.7817 13.0046 28.8652 13.1013 28.9249C13.198 28.9847 13.3083 29.0187 13.4218 29.0238C13.5354 29.029 13.6483 29.005 13.75 28.9541L21.6094 25.0244H25.3216C26.2399 25.0234 27.1203 24.6582 27.7696 24.0089C28.4189 23.3595 28.7842 22.4791 28.7852 21.5608V12.488C28.7842 11.5697 28.4189 10.6893 27.7696 10.04C27.1203 9.39063 26.2399 9.0254 25.3216 9.02441ZM27.4518 21.5608C27.451 22.1255 27.2263 22.6669 26.827 23.0662C26.4277 23.4656 25.8863 23.6903 25.3216 23.6911H21.4518C21.3484 23.6914 21.2464 23.7155 21.1537 23.7613L14.1185 27.2796V24.3577C14.1185 24.1809 14.0483 24.0114 13.9232 23.8863C13.7982 23.7613 13.6286 23.6911 13.4518 23.6911H12.2488C11.684 23.6903 11.1427 23.4656 10.7433 23.0662C10.344 22.6669 10.1193 22.1255 10.1185 21.5608V12.488C10.1193 11.9233 10.344 11.3819 10.7433 10.9826C11.1427 10.5833 11.684 10.3586 12.2488 10.3577H25.3216C25.8863 10.3586 26.4277 10.5833 26.827 10.9826C27.2263 11.3819 27.451 11.9233 27.4518 12.488V21.5608Z"
                    fill="#666666"
                  />
                  <path
                    d="M22.7839 18.3574H14.7839C14.607 18.3574 14.4375 18.4277 14.3124 18.5527C14.1874 18.6777 14.1172 18.8473 14.1172 19.0241C14.1172 19.2009 14.1874 19.3705 14.3124 19.4955C14.4375 19.6205 14.607 19.6908 14.7839 19.6908H22.7839C22.9607 19.6908 23.1302 19.6205 23.2553 19.4955C23.3803 19.3705 23.4505 19.2009 23.4505 19.0241C23.4505 18.8473 23.3803 18.6777 23.2553 18.5527C23.1302 18.4277 22.9607 18.3574 22.7839 18.3574Z"
                    fill="#666666"
                  />
                  <path
                    d="M22.7839 14.3574H14.7839C14.607 14.3574 14.4375 14.4277 14.3124 14.5527C14.1874 14.6777 14.1172 14.8473 14.1172 15.0241C14.1172 15.2009 14.1874 15.3705 14.3124 15.4955C14.4375 15.6205 14.607 15.6908 14.7839 15.6908H22.7839C22.9607 15.6908 23.1302 15.6205 23.2553 15.4955C23.3803 15.3705 23.4505 15.2009 23.4505 15.0241C23.4505 14.8473 23.3803 14.6777 23.2553 14.5527C23.1302 14.4277 22.9607 14.3574 22.7839 14.3574Z"
                    fill="#666666"
                  />
                </svg>
              </v-btn>
            </v-badge>
            <v-btn
              v-else
              icon=""
              id="show-hidden-notification"
              variant="text"
              class="show-hidden-massage pa-0"
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="#237276"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.323 0.5H4.25022C3.33192 0.500988 2.45151 0.866219 1.80218 1.51556C1.15284 2.16489 0.787609 3.0453 0.786621 3.9636V13.0364C0.787609 13.9547 1.15284 14.8351 1.80218 15.4844C2.45151 16.1338 3.33192 16.499 4.25022 16.5H4.78662V19.8333C4.7866 19.947 4.81564 20.0587 4.87097 20.158C4.92629 20.2573 5.00608 20.3408 5.10275 20.4005C5.19942 20.4603 5.30976 20.4943 5.42329 20.4994C5.53682 20.5046 5.64977 20.4806 5.75142 20.4297L13.6109 16.5H17.323C18.2413 16.499 19.1217 16.1338 19.7711 15.4844C20.4204 14.8351 20.7856 13.9547 20.7866 13.0364V3.9636C20.7856 3.0453 20.4204 2.16489 19.7711 1.51556C19.1217 0.866219 18.2413 0.500988 17.323 0.5ZM19.4533 13.0364C19.4525 13.6011 19.2278 14.1425 18.8285 14.5418C18.4291 14.9412 17.8878 15.1659 17.323 15.1667H13.4533C13.3498 15.167 13.2479 15.191 13.1552 15.2369L6.11995 18.7552V15.8333C6.11995 15.6565 6.04972 15.487 5.92469 15.3619C5.79967 15.2369 5.6301 15.1667 5.45329 15.1667H4.25022C3.68549 15.1659 3.14412 14.9412 2.74479 14.5418C2.34546 14.1425 2.12077 13.6011 2.11995 13.0364V3.9636C2.12077 3.39887 2.34546 2.8575 2.74479 2.45817C3.14412 2.05884 3.68549 1.83414 4.25022 1.83333H17.323C17.8878 1.83414 18.4291 2.05884 18.8285 2.45817C19.2278 2.8575 19.4525 3.39887 19.4533 3.9636V13.0364Z"
                  fill="#237276"
                />
                <path
                  d="M14.7868 9.8335H6.78678C6.60997 9.8335 6.4404 9.90373 6.31538 10.0288C6.19036 10.1538 6.12012 10.3234 6.12012 10.5002C6.12012 10.677 6.19036 10.8465 6.31538 10.9716C6.4404 11.0966 6.60997 11.1668 6.78678 11.1668H14.7868C14.9636 11.1668 15.1332 11.0966 15.2582 10.9716C15.3832 10.8465 15.4535 10.677 15.4535 10.5002C15.4535 10.3234 15.3832 10.1538 15.2582 10.0288C15.1332 9.90373 14.9636 9.8335 14.7868 9.8335Z"
                  fill="#237276"
                />
                <path
                  d="M14.7868 5.8335H6.78678C6.60997 5.8335 6.4404 5.90373 6.31538 6.02876C6.19036 6.15378 6.12012 6.32335 6.12012 6.50016C6.12012 6.67697 6.19036 6.84654 6.31538 6.97157C6.4404 7.09659 6.60997 7.16683 6.78678 7.16683H14.7868C14.9636 7.16683 15.1332 7.09659 15.2582 6.97157C15.3832 6.84654 15.4535 6.67697 15.4535 6.50016C15.4535 6.32335 15.3832 6.15378 15.2582 6.02876C15.1332 5.90373 14.9636 5.8335 14.7868 5.8335Z"
                  fill="#237276"
                />
              </svg>
            </v-btn>
            <v-menu
              transition="slide-x-transition"
              class="advanced-filter-massage"
              activator="#show-hidden-notification"
            >
              <v-list>
                <h4>Messages</h4>
                <v-list-item
                  v-for="(item, index) in massageArr"
                  :key="index"
                  :value="index"
                >
                  <v-list-item-title class="d-flex align-center ga-2">
                    <div class="user-img-status">
                      <div class="online-status" v-if="item.online">
                        <span></span>
                      </div>
                      <img :src="item.user_img" alt="" />
                      <img
                        v-if="item.massageFrom === 'facebook'"
                        class="social-icon"
                        src="@/assets/soft-ware-img/Component-30.svg"
                        alt=""
                      />
                      <img
                        v-else-if="item.massageFrom === 'instagram'"
                        class="social-icon"
                        src="@/assets/soft-ware-img/instgrapm.svg"
                        alt=""
                      />
                      <img
                        v-else-if="item.massageFrom === 'tiktok'"
                        class="social-icon"
                        src="@/assets/soft-ware-img/tikTopkcampaign.svg"
                        alt=""
                      />
                    </div>
                    <div class="user-msg">
                      <p>{{ item.user_name }}</p>
                      <span class="msg-text">{{ item.user_msg }}</span>
                      <button>
                        <img
                          src="@/assets/soft-ware-img/replay-msg.svg"
                          alt=""
                        />
                        <span> Reply </span>
                      </button>
                    </div>
                  </v-list-item-title>
                </v-list-item>
                <router-link to="/messages-center" class="see-all"
                  >See all messages</router-link
                >
              </v-list>
            </v-menu>
          </div>
          <div class="massage-icon">
            <v-btn
              icon=""
              id="show-hidden-columns"
              variant="text"
              class="show-hidden-massage pa-0"
            >
              <svg
                width="37"
                height="36"
                viewBox="0 0 37 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  v-if="
                    store.listNotifications.length > 0 && $i18n.locale === 'en'
                  "
                  x="21.5547"
                  y="10.001"
                  width="7"
                  height="7"
                  rx="2.678"
                  fill="#EC221F"
                />
                <rect
                  v-if="
                    store.listNotifications.length > 0 && $i18n.locale === 'ar'
                  "
                  x="10"
                  y="10.001"
                  width="7"
                  height="7"
                  rx="2.678"
                  fill="#EC221F"
                />

                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.3975 10.6938C16.697 9.68816 17.5752 8.66211 18.876 8.66211C20.1772 8.66211 21.0545 9.6882 21.3562 10.692C21.3577 10.6938 21.3598 10.6962 21.3624 10.6989C21.3686 10.7054 21.3756 10.7113 21.3822 10.7159C21.3872 10.7194 21.3903 10.7209 21.3906 10.7211C22.1479 11.0329 23.0391 11.5309 23.7362 12.4427C24.439 13.3618 24.8961 14.6377 24.8961 16.4178C24.8961 18.1927 25.0833 19.166 25.3591 19.8341C25.6008 20.4199 25.9188 20.805 26.3712 21.353C26.4373 21.433 26.5062 21.5165 26.5782 21.6047L26.5784 21.6049C27.4122 22.6262 26.6248 24.0606 25.3404 24.0606H12.4158C11.1337 24.0606 10.3331 22.6335 11.1738 21.6047C11.2459 21.5165 11.3149 21.4329 11.381 21.3528C11.8333 20.8049 12.1513 20.4198 12.3933 19.8339C12.6693 19.1657 12.857 18.1925 12.858 16.4178M16.3975 10.6938C16.3964 10.6952 16.3949 10.6968 16.3932 10.6987C16.3875 10.7046 16.3807 10.7103 16.374 10.7149C16.3678 10.7192 16.364 10.7209 16.364 10.7209L16.3636 10.721C15.6061 11.033 14.7145 11.5301 14.0173 12.4417C13.3146 13.3604 12.8581 14.6362 12.858 16.4175M18.876 10.0011C18.3606 10.0011 17.8683 10.4309 17.6778 11.0864L17.6773 11.088C17.5545 11.5066 17.2143 11.819 16.8735 11.9592C16.8734 11.9592 16.8734 11.9592 16.8733 11.9592C16.2338 12.2226 15.5799 12.6026 15.0809 13.2551C14.5874 13.9004 14.197 14.8757 14.197 16.4178V16.4182C14.196 18.2691 14.0033 19.4434 13.6309 20.3451C13.3069 21.1296 12.8545 21.6747 12.4058 22.2156C12.3405 22.2942 12.2754 22.3727 12.2107 22.4519L12.2107 22.4519C12.184 22.4845 12.1766 22.5113 12.1748 22.5314C12.1727 22.5542 12.177 22.5815 12.1913 22.6095C12.2162 22.6583 12.2782 22.7216 12.4158 22.7216H25.3404C25.4731 22.7216 25.534 22.6604 25.5594 22.6103C25.5866 22.5567 25.5832 22.5033 25.5413 22.4519C25.4767 22.3728 25.4116 22.2943 25.3464 22.2157C24.8976 21.6748 24.4452 21.1296 24.1213 20.3449C23.7491 19.4431 23.5571 18.2688 23.5571 16.4178C23.5571 14.8777 23.1664 13.902 22.6725 13.2559C22.173 12.6026 21.5189 12.2219 20.8807 11.9592C20.536 11.8174 20.1995 11.5007 20.0774 11.0891L20.0769 11.0874C19.8839 10.4306 19.3915 10.0011 18.876 10.0011Z"
                  fill="#666666"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.1968 22.7217C16.5666 22.7217 16.8663 23.0214 16.8663 23.3912V24.0607C16.8663 24.5934 17.078 25.1042 17.4546 25.4809C17.8313 25.8576 18.3422 26.0692 18.8748 26.0692C19.4075 26.0692 19.9184 25.8576 20.2951 25.4809C20.6717 25.1042 20.8833 24.5934 20.8833 24.0607V23.3912C20.8833 23.0214 21.1831 22.7217 21.5528 22.7217C21.9226 22.7217 22.2223 23.0214 22.2223 23.3912V24.0607C22.2223 24.9485 21.8697 25.7999 21.2419 26.4277C20.6141 27.0555 19.7627 27.4082 18.8748 27.4082C17.987 27.4082 17.1356 27.0555 16.5078 26.4277C15.88 25.7999 15.5273 24.9485 15.5273 24.0607V23.3912C15.5273 23.0214 15.8271 22.7217 16.1968 22.7217Z"
                  fill="#666666"
                />
              </svg>
            </v-btn>

            <v-menu
              class="advanced-filter-massage"
              activator="#show-hidden-columns"
            >
              <NotificationList :notificationsArr="store.notificationsArr" />
            </v-menu>
          </div>
          <div class="select-lang">
            <!-- <div class="custom-select">
              <select v-model="lang" @change="handleChange">
                <option class="lang-option" value="ar">{{ $t("ar") }}</option>
                <option class="lang-option" value="en">{{ $t("en") }}</option>
              </select>
            </div> -->
            <v-menu offset-y>
              <template v-slot:activator="{ props }">
                <button
                  style="width: 47px"
                  v-bind="props"
                  class="mr-2 d-flex justify-center align-center"
                  icon
                >
                  <span
                    style="
                      text-transform: uppercase;
                      font-weight: 600;
                      color: #666666;
                    "
                    class="mr-1"
                    >{{ lang }}</span
                  >
                  <Langarrow />
                </button>
              </template>

              <v-list>
                <v-list-item class="lang-list-item">
                  <v-list-item-title>
                    <img
                      width="20px"
                      height="20px"
                      :src="lang === 'ar' ? ar : en"
                      alt=""
                    />
                    {{ languages.find((langs) => langs.code === lang)?.name }}
                  </v-list-item-title>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item
                  class="lang-list-item"
                  v-for="(langs, index) in languages.filter(
                    (langs) => langs.code !== lang
                  )"
                  :key="index"
                  @click="handleChange(langs.code)"
                >
                  <v-list-item-title>
                    <img
                      width="20px"
                      height="20px"
                      :src="langs.code === 'ar' ? ar : en"
                      alt=""
                    />
                    {{ langs.name }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="go-home mr-3">
            <v-tooltip location="top">
              <template #activator="{ props }">
                <router-link
                  v-bind="props"
                  :to="{ name: 'HomePage' }"
                  style="display: flex; align-items: center; cursor: pointer"
                >
                  <Mainhome />
                </router-link>
              </template>
              <span>Go to Home</span>
            </v-tooltip>
          </div>
          <div class="user-section d-flex align-center">
            <user-dropdown />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>
<script>
import "@/assets/css/style.css";
import UserDropdown from "./UserDropdown.vue";
import NotificationList from "./NotificationList.vue";
import { notification } from "@/store/notifications/notification";
import en from "@/assets/images/uk.svg";
import ar from "@/assets/images/ar.svg";
import Mainhome from "@/components/icons/Globalnav/Mainhome.vue";
import Langarrow from "@/components/icons/Globalnav/Langarrow.vue";
export default {
  components: { UserDropdown, NotificationList, Mainhome, Langarrow },
  data: () => ({
    en,
    ar,
    store: notification(),
    menu: false,
    items: ["AR", "EN"],
    languages: [
      { flag: "flag-poland", name: "English", code: "en" },
      { flag: "flag-poland", name: "Arabic", code: "ar" },
    ],
    lang: localStorage.getItem("lang") || "en",
    select: "",
    massageArr: [],
  }),
  mounted() {
    this.store.getListNotifications();
  },
  methods: {
    handleChange(lang) {
      localStorage.setItem("lang", lang);
      this.lang = lang;
      this.$i18n.locale = lang;
      this.$i18n.fallbackLocale = lang;
      document.body.style.direction = lang === "ar" ? "rtl" : "ltr";
      document.documentElement.setAttribute("lang", lang);
    },
  },
};
</script>

<style scoped>
.lang-option {
  min-width: 150px;
}
.show-hidden-massage:hover svg path {
  fill: #fff !important;
}
.show-hidden-massage:focus svg path {
  fill: #fff !important;
}
.advanced-filter-massage .v-list {
  width: 384px !important;
  padding: 20px 20px 30px 20px !important;
  top: 14px !important;
}
.advanced-filter-massage a.see-all {
  color: #237276;
  font-size: 14px;
  font-weight: 500;
  display: block;
  text-align: end;
  text-decoration: none;
}
.advanced-filter-massage .v-list h4 {
  font-weight: 700;
  font-size: 18px;
  color: #000;
  margin-bottom: 20px;
}
.advanced-filter-massage .v-list-item {
  padding: 5px !important;
}
.v-list-item:hover {
  border-radius: 4px !important;
}
.v-list-item-title {
  padding: 6px 0 0 2px;
}
.user-img-status {
  position: relative;
}
.user-img-status img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}
.user-img-status .online-status {
  width: 13px;
  height: 13px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  top: -1px;
  left: -1px;
  border: 2px solid #fff;
}
.user-img-status .online-status span {
  display: block;
  width: 10px;
  height: 10px;
  background-color: #31a24c;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.user-img-status img.social-icon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: absolute;
  bottom: 5px;
  right: -3px;
}
.user-msg {
  line-height: normal;
}
.user-msg p {
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 5px;
}
.user-msg span.msg-text {
  color: #666666;
  font-size: 14px;
  font-weight: 400;
  display: block;
}
.user-msg button img {
  width: 16px;
  height: 16px;
}
.user-msg button {
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 10px;
}
.user-msg button span {
  font-size: 12px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
img {
  height: 60.66px;
}
.search-contein {
  display: flex;
  align-items: center;
  background-color: #174c4f14;
  padding: 5px 20px;
  border-radius: 40px;
  gap: 5px;
}
.search-contein span svg {
  display: block;
}
.search-contein input {
  margin: 10px;
  width: 100%;

  line-height: normal;
  border: none;
  outline: none;
  font-size: 14px;
}

.v-btn {
  width: fit-content !important;
  height: fit-content !important;
}
.v-btn span.btn-icon {
  background-color: transparent;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-left: 4px;
}
.v-btn:hover {
  background-color: #1f666a;
}
.v-btn {
  padding: 5px !important;
}
.v-list {
  border-radius: 20px !important;
  width: 250px !important;
}

.massage-icon span {
  /* background-color: #edf1f1; */
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
}
/* .massage-icon span:hover {
  background-color: #1f666a;
} */
.massage-icon span:hover svg path {
  fill: #e6e6e6;
}
.select-lang select {
  border: none;
  outline: none;
  /* background-color: #edf1f1; */
  color: #4d4d4d;
  /* padding: 10px; */
  border-radius: 16px;
  cursor: pointer;
  font-size: 15px;
  letter-spacing: 1.1px;
}
.select-lang select:focus {
  outline: none !important;
  border: none !important;
}
.user-section {
  gap: 8px;
}
.user-section img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.user-section p {
  color: #333333;
  font-weight: 600;
}
.user-section span {
  display: block;
  color: #999999;
  font-size: 12px;
  font-weight: 400;
}
.v-input__details {
  display: none !important;
}
.v-list-item {
  margin-bottom: 15px;
}
.v-list-item-title {
  display: flex;
  align-items: center;
  gap: 20px;
}
.v-list-item-title span {
  display: flex;
}
.custom-select {
  position: relative;
}
.custom-select * {
  text-transform: uppercase;
}
.custom-select select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* width: 90px; */
  color: rgba(77, 77, 77, 1);
  cursor: pointer;
}
:lang(ar).custom-select::after {
  right: unset;
  /* left: 1rem; */
}
.custom-select::after {
  --size: 0.3rem;
  content: "";
  position: absolute;
  /* right: 1rem; */
  left: unset;
  pointer-events: none;
}

.custom-select::after {
  border-left: var(--size) solid transparent;
  border-right: var(--size) solid transparent;
  border-top: var(--size) solid rgba(102, 102, 102, 1);
  top: 50%;
}
.lang-list-item {
  height: 20px;
}
</style>
